module.exports = __webpack_public_path__ + "static/media/marker_user.1e8ba403.png";